import React from 'react';
import { useTranslation } from 'react-i18next';
import { PieChart } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import SalaryDistributionChart from './SalaryDistributionChart';

const PayrollAnalyticsDashboard = ({ filteredEntries }) => {
  const { t } = useTranslation();
  const approved = filteredEntries.filter((e) => e.is_approved).length;
  const pending = filteredEntries.filter((e) => !e.is_approved).length;
  const total = filteredEntries.length;

  const statuses = [
    { label: t('payrollUi.analytics.approved'), count: approved, color: 'bg-green-500', percentage: total > 0 ? (approved / total) * 100 : 0 },
    { label: t('payrollUi.analytics.pending'), count: pending, color: 'bg-amber-500', percentage: total > 0 ? (pending / total) * 100 : 0 },
  ];

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <SalaryDistributionChart entries={filteredEntries} />
        <Card className="overflow-hidden">
          <CardHeader style={{ backgroundColor: "var(--lm-s2)", borderBottom: "1px solid var(--lm-border)" }}>
            <CardTitle className="flex items-center gap-2.5 text-sm font-semibold" style={{ color: "var(--lm-ink)" }}>
              <div className="p-1.5 rounded-md" style={{ backgroundColor: "rgba(94,106,210,0.10)" }}>
                <PieChart className="h-4 w-4" style={{ color: "#5e6ad2" }} />
              </div>
              <div>
                <span>{t('payrollUi.analytics.statusDist')}</span>
                <p className="text-xs font-normal mt-0.5" style={{ color: "var(--lm-ink-3)" }}>{t('payrollUi.analytics.validationState')}</p>
              </div>
            </CardTitle>
          </CardHeader>
          <CardContent className="p-6">
            <div className="space-y-4">
              {statuses.map((status, index) => (
                <div key={status.label} className="space-y-2">
                  <div className="flex justify-between items-center">
                    <span className="font-medium text-muted-foreground">{status.label}</span>
                    <span className="font-bold text-foreground">{status.count}</span>
                  </div>
                  <div className="relative h-3 bg-muted rounded-full overflow-hidden">
                    <div
                      className={`h-full ${status.color} rounded-full transition-all duration-1000 ease-out`}
                      style={{ width: `${status.percentage}%`, animationDelay: `${index * 0.2}s` }}
                    />
                  </div>
                </div>
              ))}
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default PayrollAnalyticsDashboard;
